import { Tick, Cancel } from '@sainsburys-tech/luna-icons';
import { Body2 } from '@sainsburys-tech/luna-typography';
import * as React from 'react';
export default {
  Tick,
  Cancel,
  Body2,
  React
};